// interactions/ShapeContextMenuControls.js
import * as THREE from 'three';
import {CABINET_COMMON_COLOR_PART_IDS} from "../../../../../../constants";

export default class ShapeContextMenuControls {
  constructor(threeScene, scene, camera, domElement, getSelectableGroups, onContextMenu) {
    this.threeScene    = threeScene;
    this.scene         = scene;
    this.camera        = camera;
    this.domElement    = domElement;
    this.getGroups     = getSelectableGroups;
    this.onContextMenu = onContextMenu;

    this.raycaster   = new THREE.Raycaster();
    this.mouse       = new THREE.Vector2();
    this.current     = null;
    this.highlighted = [];              // [{ mesh, originalColor }…]

    this.highlightColor = 0x4A90E2;

    this.domElement.addEventListener('pointermove',  this._onPointerMove,  false);
    this.domElement.addEventListener('pointerleave', this._onPointerLeave, false);
    this.domElement.addEventListener('contextmenu',   this._onContextMenu,  false);
  }

  dispose() {
    this.domElement.removeEventListener('pointermove',   this._onPointerMove);
    this.domElement.removeEventListener('pointerleave',  this._onPointerLeave);
    this.domElement.removeEventListener('contextmenu',    this._onContextMenu);
  }

  // ========== Highlight logic ==========
  _applyHighlight(group) {
    this.highlighted = [];
    group.traverse(mesh => {
      if (mesh.isMesh && mesh.material.emissive) {
        // clone material to avoid multiple highlighting
        if (!mesh.userData.hasOwnProperty('origMaterial')) {
          mesh.userData.origMaterial = mesh.material;
          mesh.material = mesh.material.clone();
        }
        const origColor = mesh.material.emissive.getHex();
        if (origColor === this.highlightColor) return;
        this.highlighted.push({ mesh, color: origColor });
        mesh.material.emissive.setHex(this.highlightColor);
      }
    });
  }

  _clearHighlight() {
    this.highlighted.forEach(({ mesh, color }) => {
      mesh.material.emissive.setHex(color);
    });
    this.highlighted = [];
  }

  // ========== Event handlers ==========

  _onPointerMove = event => {
    const rect = this.domElement.getBoundingClientRect();
    this.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    this.mouse.y = -((event.clientY - rect.top)  / rect.height) * 2 + 1;
    this.raycaster.setFromCamera(this.mouse, this.camera);

    const groups = this.getGroups();
    const hits   = this.raycaster.intersectObjects(groups, true);

    if (hits.length) {
      let obj = hits[0].object;

      while (obj.parent && !groups.includes(obj)) obj = obj.parent;

      if (obj !== this.current && obj.userData && CABINET_COMMON_COLOR_PART_IDS.includes(obj.userData.partId)) {
        this._clearHighlight();
        this.current = obj;
        this._applyHighlight(obj);
      }
    } else {
      this._clearHighlight();
      this.current = null;
    }
  }

  _onPointerLeave = () => {
    this._clearHighlight();
    this.current = null;
  }

  _onContextMenu = event => {
    if (!this.current) return;
    event.preventDefault();
    this.onContextMenu(this.current, event);
  }
}
